import { gql } from '@apollo/client'

export const termsQuery = gql`
  query getTerms(
    $termsInput: Credit_BusinessCredit_TermsInput!
    $style: Credit_BusinessCredit_FormattedContentStyle!
  ) {
    credit {
      businessCredit {
        terms(input: $termsInput) {
          version
          formattedContent {
            content(formatOptions: { style: $style })
          }
        }
      }
    }
  }
`

export const getApplicationByIdQuery = gql`
  query getApplicationById($applicationId: Credit_ApplicationID!) {
    credit {
      businessCredit {
        application(input: { id: $applicationId }) {
          id
          countryCode
          referenceId
          creditProductIdentifier
          originationUrl
          status
          statusReasons
          tags
          portalAccess {
            sessionId
            userToken
            url
            userId
          }
          business {
            legalBusinessName
            doingBusinessAsName
            formationDate
            formattedFormationDate {
              numericMonthDayShortYear
              numericMonthLongYear
            }
            financialProfile {
              totalAnnualBusinessRevenue {
                currencyCode
                value
              }
            }
            incorporationRegion
            numberOfFullTimeEmployees
            industryType
            subIndustryCode
            organizationType
            phones {
              countryCode
              nationalNumber
              extensionNumber
              type
              primary
            }
            address {
              countryCode
              addressLine1
              addressLine2
              addressLine3
              adminArea1
              adminArea2
              adminArea3
              adminArea4
              postalCode
            }
            websiteUrl
            loanHistory {
              wasPreviouslyFunded
              previousLoansPaidOff
            }
          }
          device {
            clientIpAddress
          }
          loanPurpose
          guarantor {
            emailAddress
            alternateEmailAddress
            businessAssociation {
              ownershipPercentage
              formattedOwnershipPercentage {
                percentage
              }
              roles
            }
            phones {
              countryCode
              nationalNumber
              extensionNumber
              type
              primary
            }
            name {
              givenName
              surname
            }
            address {
              countryCode
              addressLine1
              addressLine2
              addressLine3
              adminArea1
              adminArea2
              adminArea3
              adminArea4
              postalCode
            }
          }
          productDiscovery {
            source
            invitationCode
          }
          consents {
            type
            status
            recordedTime
          }
          campaign {
            id
          }
        }
      }
    }
  }
`

export const getApplicationByIdPollingQuery = gql`
  query getApplicationById($applicationId: Credit_ApplicationID!) {
    credit {
      businessCredit {
        application(input: { id: $applicationId }) {
          id
          portalAccess {
            sessionId
            userToken
            url
            userId
          }
          statusReasons
        }
      }
    }
  }
`

export const getEligibility = gql`
  query getEligibility(
    $creditProductIdentifier: Credit_BusinessCredit_CreditProductIdentifier!
    $partnerApplicationId: Credit_BusinessCredit_PartnerApplicationID
  ) {
    credit {
      businessCredit {
        eligibility(
          input: {
            creditProductIdentifier: $creditProductIdentifier
            partnerApplicationId: $partnerApplicationId
          }
        ) {
          status
          offers {
            type
            preapproval {
              category
            }
            offerExpiryDate
          }
        }
      }
    }
  }
`

export const getIndustriesByProductIdentifier = gql`
  query getIndustriesByProductIdentifier(
    $productIdentifier: Credit_BusinessCredit_CreditProductIdentifier!
  ) {
    credit {
      businessCredit {
        industries(input: { creditProductIdentifier: $productIdentifier }) {
          industries {
            subIndustries {
              code
              name
            }
            name
          }
        }
      }
    }
  }
`

export const renewalApplicationPrefillQuery = gql`
  query renewalApplicationPrefillQuery(
    $productIdentifier: Credit_BusinessCredit_CreditProductIdentifier!
    $renewalToken: String
  ) {
    credit {
      businessCredit {
        applicationPrefillData(
          input: {
            creditProductIdentifier: $productIdentifier
            renewalToken: $renewalToken
          }
        ) {
          business {
            legalBusinessName
            doingBusinessAsName
            formationDate
            formattedFormationDate {
              numericMonthDayShortYear
              numericMonthLongYear
            }
            incorporationRegion
            numberOfFullTimeEmployees
            industryType
            subIndustryCode
            organizationType
            address {
              countryCode
              addressLine1
              addressLine2
              addressLine3
              adminArea1
              adminArea2
              adminArea3
              adminArea4
              postalCode
            }
            phones {
              nationalNumber
              countryCode
            }
          }
          guarantor {
            emailAddress
            alternateEmailAddress
            businessAssociation {
              ownershipPercentage
              formattedOwnershipPercentage {
                percentage
              }
              roles
            }
            phones {
              countryCode
              nationalNumber
              extensionNumber
              type
              primary
            }
            name {
              givenName
              surname
            }
            address {
              countryCode
              addressLine1
              addressLine2
              addressLine3
              adminArea1
              adminArea2
              adminArea3
              adminArea4
              postalCode
            }
          }
          portalAccess {
            sessionId
            renewalRoutingUrls {
              type
              endpoint
            }
          }
        }
      }
    }
  }
`

export const getCreditApplicationDataQuery = gql`
  query {
    id @client
    legalBusinessName @client
    firstName @client
    lastName @client
    phoneNumber @client
    phoneNumberType @client
    emailAddress @client
    primaryLoanPurpose @client
    howDidYouHearAboutThisProduct @client
    agreedToTermsAndConditions @client
    homeAddress1 @client
    homeAddress2 @client
    city @client
    state @client
    zip @client
    personalPhoneNumber @client
    personalPhoneNumberType @client
    homeBasedBusiness @client
    businessAddress1 @client
    businessAddress2 @client
    businessCity @client
    businessState @client
    businessZip @client
    businessPhoneNumber @client
    businessWebAddress @client
    businessEntityType @client
    doingBusinessAs @client
    doingBusinessAsRadio @client
    stateOfIncorporation @client
    totalAnnualBusinessRevenue @client
    businessStartDate @client
    numberOfFullTimeEmployees @client
    businessIndustry @client
    businessSubIndustry @client
    dateOfBirth @client
    socialSecurityNumber @client
    federalTaxId @client
    percentageOfOwnership @client
  }
`
